// extracted by mini-css-extract-plugin
module.exports = {"qrCode":"_45cfee06"};